import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const IMG = "/assets/pausa-scrivania.jpg";

export const EditorialBreak = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="editorial-break" className="relative h-[26rem] overflow-hidden sm:h-[32rem]">
      <motion.img
        src={IMG}
        alt="Un caffè fumante e un taccuino aperto vicino a una finestra illuminata dal sole"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-espresso/50" />
      <div className="relative mx-auto flex h-full max-w-4xl items-center justify-center px-5 text-center sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-2xl italic leading-snug text-linen [text-shadow:0_2px_24px_rgba(30,24,21,0.6)] sm:text-3xl lg:text-4xl"
        >
          "Un'ora per te non è tempo perso.
          <span className="block text-rose">È il primo investimento che fai sulla tua attività."</span>
        </motion.p>
      </div>
    </section>
  );
};
